import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyAdminComponent } from './company-admin/company-admin.component';
import { MatIconModule } from '@angular/material/icon';
import { TableModule } from '../../components/table/table.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    CompanyAdminComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,

    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,

    MatCardModule,
    MatDividerModule,

    MatTableModule,
    MatSlideToggleModule,
    MatSelectModule,


    MatInputModule,
    MatDatepickerModule,
    MatDialogModule
  ]
})
export class CompanyAdminModule { }
